import React, { useState } from 'react';
import OverWindow from '../../../Elements/TabList/OverWindow';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import ErrorMessage from '../../../Elements/ErrorMessage';
import TpPlatformInvoiceBravoJobItem from '../../../Domain/ThirdParty/TpPlatformInvoice/TpPlatformInvoiceBravoJobItem';
import TpPlatformInvoiceService from '../../../Services/TpPlatformInvoiceService';
import TpPlatformInvoiceBravoJobSearchParams from './TpPlatformInvoiceBravoJobSearchParams';

const exportMessage =
  'File creation has started and your report will be available in your personal download menu soon. You can continue to use the system while your request is being processed.';

// The Bravo-jobs popup shared by the two entry points (CD-5294): the invoice list's
// "View Bravo Jobs" row action (invoice-level — office/client/period left empty, the
// backend fans out over the invoice's frozen Assignment rows) and the Summarized
// Invoice Items count link (per-client — the clicked row's period/office/client). The
// toolbar's Excel action exports exactly the popup's scope. The list is a live
// re-query, so it can exceed the frozen Bravo Shop Count when later billing runs
// stamped more jobs into the period — expected, that gap is the reconciliation signal.
const TpPlatformInvoiceBravoJobsPopup = ({
  title = 'Bravo Jobs',
  thirdPartySource = '',
  thirdPartyInvoiceId = '',
  billingPeriod = '',
  officeId = '',
  clientId = '',
  clickOnCancel = () => {},
}) => {
  const stampScope = (item) => {
    item.ThirdPartySource = thirdPartySource;
    item.ThirdPartyInvoiceId = thirdPartyInvoiceId;
    item.BillingPeriod = billingPeriod;
    item.OfficeId = officeId;
    item.ClientId = clientId;
    return item;
  };

  const [searchItem, setSearchItem] = useState<any>(() =>
    stampScope(new (TpPlatformInvoiceBravoJobSearchParams as any)())
  );

  // Scoping values are re-stamped on every search so the user cannot search their way
  // out of the popup's invoice / client scope.
  const startSearch = (newSearchItem) => setSearchItem(stampScope({ ...newSearchItem }));

  const handleExportClick = () => {
    TpPlatformInvoiceService.ExportBravoJobsToExcel(searchItem).catch(() => ErrorMessage.SetErrorMessage('TPPBJ02'));
    ErrorMessage.SetSuccessWithWait(exportMessage);
  };

  return (
    <OverWindow
      title={title}
      clickOnCancel={clickOnCancel}
      closeOnClickOutside={false}
      maxWidth={1200}
    >
      <div className='verticalScroll showassignmentlistheight'>
        <TabOfDataTable
          type={TpPlatformInvoiceBravoJobItem}
          serviceFunction={TpPlatformInvoiceService.GetBravoJobsBySearching}
          convertDBItemsFunction={TpPlatformInvoiceService.ConvertDBBravoJobItems}
          searchItem={searchItem}
          searchParamsType={TpPlatformInvoiceBravoJobSearchParams}
          showSearchStrip={true}
          clickOnStartSearch={startSearch}
          popupEnabled={false}
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in client, office, survey, location, job IDs...'
          errorCode='TPPBJ01'
          useClickOnClearAll={true}
          isExportExcelDisabled={false}
          clickOnExportExcel={handleExportClick}
          excelExportTooltipMessage='Download Excel'
        />
      </div>
    </OverWindow>
  );
};

export default TpPlatformInvoiceBravoJobsPopup;
